import { CoreParams } from 'mm-client-core';
import { Reducer } from 'redux';
import { FunctionComponent } from 'react';
import { ClientAPIEvent } from '../client/clientAPI';
import { AppState } from '../store/initialStateRegistration';

interface Registration {
    component: any
    rootReducer: any
}

const validateRegistration = (registration: Registration) => {
    if (!registration.component) {
        throw new Error('missing property "component" in TemplateRegistration');
    }
    if (!registration.rootReducer) {
        throw new Error('missing property "rootReducer" in TemplateRegistration');
    }
};

export class TemplateRegistration {
    // @ts-ignore
    component: FunctionComponent<any>;

    getCoreParams: (state: AppState) => (CoreParams | {});

    clientAPIEvents: Array<ClientAPIEvent>;

    // @ts-ignore
    rootReducer: any;

    constructor() {
        this.getCoreParams = () => ({});
        this.clientAPIEvents = [];
        return this;
    }

    setComponent(component: FunctionComponent<any>) {
        this.component = component;
        return this;
    }

    setRootReducer(rootReducer: any) {
        this.rootReducer = rootReducer;
        return this;
    }

    addClientAPIEvent(clientAPIEvent: ClientAPIEvent) {
        this.clientAPIEvents = [
            ...this.clientAPIEvents,
            clientAPIEvent,
        ];
        return this;
    }

    setCoreParams(getCoreParams: (state: AppState) => CoreParams) {
        this.getCoreParams = getCoreParams;
        return this;
    }

    build() {
        const registration = {
            component: this.component,
            getCoreParams: this.getCoreParams,
            clientAPIEvents: this.clientAPIEvents,
            rootReducer: this.rootReducer as Reducer<AppState>,
        };
        validateRegistration(registration);
        return registration;
    }
}
